export const CALENDLY_URL = "https://calendly.com/joyce-zfc/30min";
export const neuro42DicomViewer = "https://neuro42-dicom-viewer.web.app/";
export const googleformresponses = "https://docs.google.com/forms/d/1LKys39PkMc6OBMxftDhOcmCaOfY60FB6lGIvyXquwcE/edit"